import {action, makeObservable, observable} from "mobx";
import {makePersistable} from "mobx-persist-store";

enum DebugMessageType {
	INFO,
	ERROR
}

export class DebugMessage {
	error: boolean
	ts: Date;
	message: string;

	constructor(type: DebugMessageType, ts: Date, message: string) {
		this.error = (type == DebugMessageType.ERROR)
		this.ts = ts;
		this.message = message;
	}

}

export interface IDebug {
	readonly messages: DebugMessage[];

	info(message: string): void;
	error(message: string): void;
	clear(): void;
}

export class Debug implements IDebug{
	messages: DebugMessage[] = [];

	constructor() {
		makeObservable(this, {
			messages: observable,
			info: action,
			error: action,
			clear: action
		})

		makePersistable(this, {
			name: 'debug',
			properties: ["messages"],
			storage: window.localStorage
		});
	}

	#add(message: DebugMessage) {
		if (this.messages.length > 500)
			this.messages.shift()
		this.messages.push(message)
	}

	info(message: string): void
	{
		this.#add(new DebugMessage(DebugMessageType.INFO, new Date(), message))
	}

	error(message: string): void
	{
    console.log("error - ", message)
		this.#add(new DebugMessage(DebugMessageType.ERROR, new Date(), message))
	}

	clear() {
		this.messages = [];
	}
}
